// @flow

import _ from 'lodash';
import moment from 'moment';

import { Spreadsheet } from '../models/spreadsheet';

export class StoresSpreadsheet extends Spreadsheet {
    name: string = `lojas_selecionadas`;
    static exportAsExcel = props => (new StoresSpreadsheet()).mount(props).create().saveAsExcel();

    mount (dataSource: any) {
        const period = dataSource[0].Period;
        const sectionColumns: any = {
            main: [
                { key: 'IdOriginal', text: 'CD CONC', textAlign: 'center' },
                { key: 'Bandeira', text: 'BANDEIRA' },
                { key: 'DateOpeningFormat', text: 'ABERTURA CNPJ', textAlign: 'center', format: 'text' },
                { key: 'Nome', text: 'NOME' },
                { key: 'Grupo', text: 'GRUPO' },
                { key: 'Cnpj', text: 'CNPJ' },
                { key: 'Tipo', text: 'TIPO', textAlign: 'center' },
            ],
            sales: [
                { key: 'TotalVendas', text: 'VENDA TOTAL', textAlign: 'center' },
                { key: 'MediaMensal', text: 'VENDA MÉDIA', textAlign: 'center' }
            ],
            address: [
                { key: 'Logradouro', text: 'LOGRADOURO' },
                { key: 'Bairro', text: 'BAIRRO' },
                { key: 'Municipio', text: 'CIDADE' },
                { key: 'UF', text: 'UF', textAlign: 'center' },
                { key: 'Cep', text: 'CEP', textAlign: 'center' },
                { key: 'Geocode', text: 'GEOCODIGO', textAlign: 'center' },
                { key: 'IdPma', text: 'CD PMA', textAlign : 'center' },
                { key: 'NamePma', text: 'NOME PMA', textAlign : 'center' },
                { key: 'IdAreaOperational', text: 'CD AREA', textAlign : 'center' },
                { key: 'NameAreaOperational', text: 'NOME ÁREA OP', textAlign : 'center' }
            ]
        };

        const sections: Array<any> = [
            { key: 'main', text: 'DEALER', index: 0 },
            { key: 'sales', text: `PERÍODO: ${period}`, index: sectionColumns.main.length },
            { key: 'address', text: 'LOCALIZAÇÂO', index: sectionColumns.main.length + sectionColumns.sales.length }
        ];

        const baseStyle: any = {
            textAlign: 'left',
            fontSize: 11,
            verticalAlign: 'center',
            fontFamily: 'Calibri'
        };

        const baseHeaderStyle: any = {
            color: '#FFFFFF',
            fontSize: 11,
            bold: true,
            textAlign: 'center',
            verticalAlign: 'center',
            fontFamily: 'Calibri'
        };

        const baseColorStyle: any = {
            header: '#616161',
            main: '#244062',
            sales: '#E26B0A',
            matrix: '#244062',
            address: '#244062',
            updated: '#244062'
        };

        const baseBorderColorStyle: any = {
            main: '#eee',
            sales: '#eee',
            matrix: '#eee',
            address: '#eee'
        };

        const baseBackgroundColorStyle: any = {
            main: '#fafafa',
            sales: '#fafafa',
            matrix: '#fafafa',
            address: '#fafafa'
        };

        const headerStyle = _.reduce(sections, (acc: any, section: any) => {
            acc[section.key] = _.assign({}, baseHeaderStyle, { background: baseColorStyle[section.key] });
            return acc;
        }, {});

        const getCellStyle = (data: any, key: any) => {
            return _.assign({}, baseStyle, {
                background: baseBackgroundColorStyle[key],
                borderLeft: { color: baseBorderColorStyle[key], size: 1 },
                borderRight: { color: baseBorderColorStyle[key], size: 1 },
                borderTop: { color: baseBorderColorStyle[key], size: 1 },
                borderBottom: { color: baseBorderColorStyle[key], size: 1 }
            });
        };

        this.workbookOptions = {
                sheets: _.map(_(dataSource)
                    .groupBy(d => d.tabName || 'DEALERS')
                    .value(), (data: any) => (
                {
                    name: 'DEALERS',
                    frozenColumns: 2,
                    frozenRows: 2,
                    filter: {
                        ref: `A2:${this.columnIndex[sections[2].index + sectionColumns.address.length - 1]}${data.length + 2}`,
                        columns: []
                    },
                    rows: [
                        {
                            cells: [
                                ..._.map(sections, (section: any) =>
                                    _.assign({}, headerStyle[section.key], {
                                        value: section.text,
                                        index: section.index,
                                        borderLeft: { color: baseBorderColorStyle[section.key], size: 1 },
                                        borderRight: { color: baseBorderColorStyle[section.key], size: 1 }
                                    }))
                            ]
                        },
                        {
                            cells: [
                                ..._(sectionColumns)
                                    .map((columns: any, key: any) =>
                                        _.map(columns, (cell: any) =>
                                            _.assign({}, headerStyle[key], {
                                                value: cell.text,
                                                wrap: true,
                                                borderLeft: { color: baseBorderColorStyle[key], size: 1 },
                                                borderRight: { color: baseBorderColorStyle[key], size: 1 },
                                                borderTop: { color: baseBorderColorStyle[key], size: 1 },
                                                borderBottom: { color: baseBorderColorStyle[key], size: 1 }
                                            })))
                                    .flatten()
                                    .value()
                            ]
                        },
                        ..._.map(data, d => {
                            return ({
                                cells: [
                                    ..._(sectionColumns)
                                        .map((columns: any, key: any) =>
                                            _.map(columns, (cell: any) => {
                                                if (cell.key === 'updatedAt') {
                                                    return _.assign({}, getCellStyle(d[cell.key], key), {
                                                        value: moment(d[cell.key]).format('L'),
                                                        textAlign: cell.textAlign
                                                    });
                                                } else {
                                                    const value = _.isArray(cell.key) ? d[_.find(cell.key, (k) => d[k])] : d[cell.key];
                                                    return _.assign({}, getCellStyle(d[cell.key], key), {
                                                        value: _.isString(value) ? value.toUpperCase() : value,
                                                        textAlign: cell.textAlign
                                                    });
                                                }
                                            }))
                                        .flatten()
                                        .value()
                                ]
                            });
                        })
                    ],
                    columns: [
                        {
                            index: 0,
                            width: 80
                        },
                        {
                            index: 1,
                            width: 200
                        },
                        {
                            index: 2,
                            width: 150
                        },
                        {
                            index: 3,
                            width: 150
                        },
                        {
                            index: 4,
                            width: 150
                        },
                        {
                            index: 5,
                            width: 180
                        },
                        {
                            index: 6,
                            width: 150
                        },
                        {
                            index: 7,
                            width: 100
                        },
                        {
                            index: 8,
                            width: 100
                        },
                        {
                            index: 9,
                            width: 300
                        },
                        {
                            index: 10,
                            width: 150
                        },
                        {
                            index: 11,
                            width: 150
                        },
                        {
                            index: 12,
                            width: 50
                        },
                        {
                            index: 13,
                            width: 100
                        },
                        {
                            index: 14,
                            width: 150
                        },
                        {
                            index: 15,
                            width: 100
                        },
                        {
                            index: 16,
                            width: 100
                        }
                    ],
                    showGridLines: true,
                    mergedCells: [
                        `A1:${this.columnIndex[sections[1].index - 1]}1`,
                        `${this.columnIndex[sections[1].index]}1:${this.columnIndex[sections[2].index - 1]}1`,
                        `${this.columnIndex[sections[2].index]}1:${this.columnIndex[sections[2].index + sectionColumns.address.length - 1]}1`
                    ]
                }
            ))
        };

        return this;
    }
}



// WEBPACK FOOTER //
// ./src/spreadsheets/stores-spreadsheet.js